import Immutable from 'immutable';
import { createSrchStr, getSrchTokens, matchSrchTokens } from "./localsearch";



export default function StaticLookup(rows) {
	if (!(this instanceof StaticLookup)) {
		return new StaticLookup(rows);
	}

	var me = this;
	rows = createSrchStr(rows);

	this.supportsCombo = true;

	this.isEmpty = function() {
		return rows.size === 0;
	};

	this.clone = function(keyFilter) {
		return new StaticLookup(rows.filter(row => keyFilter(row.get('key'))));
	}

	this.size = function() {
		return rows.size;
	};

	this.getTimeout = function() {
		return 0;
	};

	this.getRows = function(filter) {
		const tokens = getSrchTokens(filter);
		return rows.filter(row => matchSrchTokens(tokens, row.get('srchStr')))
	};

	this.getItems = function() {
		if (!this._items) {
			this._items = this.getRows().map(row => Immutable.Map({
				key: row.get('key'),
				text: row.getIn(['cells', 0])
			}));
		}
		return this._items;
	};

	this.getTextMap = function() {
		if (!me._textMap) {
			let res = {};
			rows.forEach(r => {
				res[r.get('key')] = r.get('text') || r.getIn(['cells', 0]);
			});
			me._textMap = Object.freeze(res);
		}
		return me._textMap;
	};

	this.getMultiText = function(keys) {
		return this.getTextMap();
	};

	this.getText = function(value) {
		return me.getTextMap()[value] || '';
		//return (rows.find(row => row.get('key') === value) || EMPTY_MAP).getIn(['cells', 0])
	};
}

